import EditIcon from "@/assets/EditIcon";
import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import FileUploader from "./FileUploader";
import { FaEye } from "react-icons/fa";
import { downloadFile, downloadFileZip } from "@/services/downloadService";
import { useEffect, useState } from "react";

type EditFileProps = {
    fileId?: string,
    isDisabled?: boolean,
    isEditable?: boolean,
    isInvalid?: boolean,
    type: string,
    title: string,
    isDownloadFolder?: boolean,
    folderType?: number // required if isDownloadFolder is true, not if false
    handleDrop: (files: File[]) => void,
};

const EditFile = ({
    fileId,
    isDisabled = false,
    isEditable = true,
    isInvalid = false,
    type,
    title,
    isDownloadFolder = false,
    folderType = 0,
    handleDrop,
}: EditFileProps) => {
    const [isEditing, setEditing] = useState<boolean>(isEditable && !fileId);

    const toggleEdit = () => {
        if (isDisabled) return;
        if (isEditing){
            handleDrop([]);
        }
        setEditing(!isEditing);
    };

    const handleDownload = async (isDownloadFolder: boolean, idFile: string, folderType: number) => {
        if (isDownloadFolder){
            await downloadFileZip(idFile, folderType);
        } else {
					downloadFile(idFile);
        }
    };

    useEffect(() => {
        if (!isEditable || fileId) {
            setEditing(false);
            return;
        }

        // Keep uploader visible for newly selected files even when parent toggles disabled during submit.
        setEditing(true);
    }, [fileId, isEditable]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

            {(fileId || !isEditable) && <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box
                    borderWidth="1px"
                    borderRadius="md"
                    padding={4}
                    backgroundColor={fileId ? "green.50" : "yellow.50"}
                    borderColor={fileId ? "green.200" : "yellow.200"}
                    width="100%"
                    marginBottom="15px"
                >
                    <HStack
                        borderWidth="1px"
                        borderRadius="md"
                        padding={3}
                        backgroundColor="white"
                        justifyContent="space-between"
                        width="100%"
                    >
                        <HStack>
                            <Text>{fileId ? title : 'No file uploaded'}</Text>
                        </HStack>
                        <HStack cursor='pointer' onClick={() => {
                            if (fileId) {
                                handleDownload(isDownloadFolder, fileId, folderType)
                            }
                        }}>
                            {fileId && <Icon as={FaEye} />}
                            <Text>{fileId ? 'Download Document' : ''}</Text>
                        </HStack>
                    </HStack>
                </Box>
                {isEditable && !isDisabled && <EditIcon
                    style={{ marginLeft: '10px', marginTop: '-20px', cursor: 'pointer' }}
                    onClick={toggleEdit}
                />}
            </div>}

            {isEditing &&
            <div style={{ width: '100%' }}>
                <FileUploader
                    onDrop={handleDrop}
                    isInvalid={isInvalid}
                    type={type}
                    isDisabled={isDisabled}
                    isPadding={false}
                />
            </div>}

        </div>
    );
};

export default EditFile;
